// # src/Routes.jsx
    
import React from "react";
import { Routes, Route, /*Navigate*/ } from "react-router-dom";
// import Dashboard from "./components/Sidebar/Sidebar";  
// import SocialCards from "./components/SocialCards/SocialCards";
// import { getToken } from "./helpers";
import SignIn from "./pages/SignIn/SignIn";
import SignUp from "./pages/SignUp/SignUp";
import Reset from "./pages/password/reset";
import Forgot from "./pages/password/forgot";

const AppRoutes = () => {
  return (
    <Routes>
      {/* <Route path="/" element={<SocialCards />} /> */}
      <Route exact path="/signin" element={<SignIn />} />
      <Route exact path="/reset" element={<Reset />} />
      <Route exact path="/forgot" element={<Forgot />} />
      <Route path="/signup" element={<SignUp />} />
      {/* <Route
        path="/profile"
        element={getToken() ? <Dashboard /> : <Navigate to="/dashboard" />}
      /> */}
    </Routes>
  );
};

export default AppRoutes;